import { PriceBookAccountingCodeModel, PriceModel } from "./price-book.model";
import { Attachment } from "./material-item.model";

export class ServiceItemModel{
    ID: string
    ItemNumber: string
    IsFrequentlyUsed: boolean
    Description: string
    Category: {ID:string}
    AccountingCode: PriceBookAccountingCodeModel
    Note: string
    Cost:string
    IsPriceEditAllowed:boolean
    IsDescriptionEditAllowed: boolean
    IsDiscountExcluded:boolean
    IsTaxable:boolean
    IsAgreementExcluded:boolean
    StandardCost:string
    Prices:PriceModel[]
    IsActive:boolean
    MaterialItems:any;
    LaborItems:any;
    Attachments:Attachment[];
    ModifyDate;
    public constructor(){
        this.ID=""
        this.ItemNumber="";
        this.Prices = [];
        this.Attachments = [new Attachment()];
        this.LaborItems=[];
        this.MaterialItems=[];
        this.ModifyDate ="";
    } 
}